import React from 'react';
import * as Styled from "./FullScreenPreview.styled";
import previewImage from "../../../assets/images/layout/preview.png";
import { FullScreenModal, HeaderLogo, IPropsBasicModal } from '../../../libs';
export const FullScreenPreview: React.FC<IPropsBasicModal> = ({ show, onHide }) => {
    const handleBack = () => {
        console.log("Fullscreen Preview clicked");
        onHide();
    };

    const handlePublish = () => {
        console.log("Save clicked");
    };

    return (
        <FullScreenModal
            show={show}
            onHide={onHide}
            header={
                <Styled.ModalHeader closeVariant="white">
                    <Styled.LeftSection>
                        <HeaderLogo />
                    </Styled.LeftSection>
                    <Styled.RightSection>
                        <Styled.CustomButton variant="outline-secondary" onClick={handleBack}>
                            Back
                        </Styled.CustomButton>
                        <Styled.SaveButton variant="primary" onClick={handlePublish}>
                            Publish
                        </Styled.SaveButton>
                    </Styled.RightSection>
                </Styled.ModalHeader>
            }
            body={
                <Styled.ModalBodyWrapper>
                    <Styled.FullscreenImage src={previewImage} alt="Preview" />
                </Styled.ModalBodyWrapper>
            }
        />
    );
};
